module.exports = __webpack_public_path__ + "e4b2a7db7bb2cd7522e37d07912338f1.png";